import { GetClientResponse } from '../@types/api'
import {
  ActivateClientPayload,
  DeleteClientPayload,
  PauseClientPayload,
  UpdateClientPayload,
} from '../api/api'
import {
  ActionTypes,
  SET_APP_ERROR,
  AppError,
  CLEAR_APP_ERROR,
  GET_COUNTERS,
  CountersPayload,
  SET_COUNTERS,
  SET_TOKEN,
  SET_GOOGLE_TOKEN,
  GET_CLIENTS,
  ClientsPayload,
  SET_CLIENTS,
  SET_CLIENT,
  UPDATE_CLIENT,
  LOG_OUT,
  DELETE_CLIENT,
  PAUSE_CLIENT,
  ACTIVATE_CLIENT,
} from './types'

export function getCounters(): ActionTypes {
  return {
    type: GET_COUNTERS,
  }
}
export function getClients(): ActionTypes {
  return {
    type: GET_CLIENTS,
  }
}

export function setToken(payload: string): ActionTypes {
  return {
    type: SET_TOKEN,
    payload,
  }
}

export function setGoogleToken(payload: string): ActionTypes {
  return {
    type: SET_GOOGLE_TOKEN,
    payload,
  }
}

export function setCounters(payload: CountersPayload): ActionTypes {
  return {
    type: SET_COUNTERS,
    payload,
  }
}

export function setClients(payload: ClientsPayload): ActionTypes {
  return {
    type: SET_CLIENTS,
    payload,
  }
}

export function setClient(payload: GetClientResponse): ActionTypes {
  return {
    type: SET_CLIENT,
    payload,
  }
}

export function updateClient(payload: UpdateClientPayload): ActionTypes {
  return {
    type: UPDATE_CLIENT,
    payload,
  }
}

export function deleteClient(payload: DeleteClientPayload): ActionTypes {
  return {
    type: DELETE_CLIENT,
    payload,
  }
}

export function pauseClient(payload: PauseClientPayload): ActionTypes {
  return {
    type: PAUSE_CLIENT,
    payload,
  }
}

export function activateClient(payload: ActivateClientPayload): ActionTypes {
  return {
    type: ACTIVATE_CLIENT,
    payload,
  }
}

export function setAppError(error: AppError): ActionTypes {
  return {
    type: SET_APP_ERROR,
    payload: error,
  }
}

export function clearAppError(): ActionTypes {
  return {
    type: CLEAR_APP_ERROR,
  }
}

export function logout(): ActionTypes {
  return {
    type: LOG_OUT,
  }
}
